// Utility functions for API calls with CORS handling

const GOOGLE_SCRIPT_URL = process.env.NODE_ENV === 'development' 
  ? "/macros/s/AKfycbzhPraMMhD7oK-KfyNvwbZmAomAeLuXXKN0PptbiKFRzPJUwaBPhZJYhAiEaJixWxfi/exec"
  : "https://script.google.com/macros/s/AKfycbzhPraMMhD7oK-KfyNvwbZmAomAeLuXXKN0PptbiKFRzPJUwaBPhZJYhAiEaJixWxfi/exec";

export const submitToGoogleSheets = async (formData) => {
  try {
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: "POST",
      mode: process.env.NODE_ENV === 'development' ? "cors" : "no-cors",
      body: formData,
    });
    
    // With no-cors mode, we can't read the response, so we assume success
    return { success: true };
  } catch (error) {
    console.error("Error submitting to Google Sheets:", error);
    throw error;
  }
};

export const submitToCRM = async (crmData) => {
  const url = "https://enterprise.godial.cc/meta/api/externals/contact/add?access_token=nbcLc99ivtoh5FO8xqGEOZEW6ddcb4szdtvHdVNCeTh980VQNehbfScBK0MvbQTb";
  
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(crmData),
    });
    
    if (!response.ok) {
      throw new Error(`CRM API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error("Error submitting to CRM:", error);
    throw error;
  }
};

// Alternative approach using a proxy service for development
export const submitToGoogleSheetsWithProxy = async (formData) => {
  const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  const targetUrl = "https://script.google.com/macros/s/AKfycbzhPraMMhD7oK-KfyNvwbZmAomAeLuXXKN0PptbiKFRzPJUwaBPhZJYhAiEaJixWxfi/exec";
  
  try {
    const response = await fetch(proxyUrl + targetUrl, {
      method: "POST",
      body: formData,
    });
    
    return await response.json();
  } catch (error) {
    console.error("Error with proxy request:", error);
    throw error;
  }
};